/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import AllReports from "../../../MiddleMileOperations/ExceptionReports/allReports";
const CashBooking = () => {
    const embeddedId = "38104983-8791-40e5-9912-6be5255b832a";
    const rsl = [];
    const title = "Cash Bookings";
    return (
        <div>
            <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
        </div>
    );
};

export default CashBooking;
